import { demoActivityLogs } from '@/mocks/demoData';
import type { ActivityLog } from '@/mocks/data';

let logs: ActivityLog[] = [...demoActivityLogs];

export function getActivityLogs(): ActivityLog[] {
  return logs;
}

export function getRecentLogs(count: number = 10): ActivityLog[] {
  return [...logs].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()).slice(0, count);
}

export function addActivityLog(log: Omit<ActivityLog, 'id' | 'created_at'>): void {
  const newLog: ActivityLog = {
    ...log,
    id: `log-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
    created_at: new Date().toISOString(),
  };
  logs = [newLog, ...logs];
}